import { useContext } from "react";
import { HighlightedParagraphsContext } from "../contexts/HighlightedParagraphsContext";

const useHighlightedParagraphs = () => useContext(HighlightedParagraphsContext);

export default useHighlightedParagraphs;
